// src/components/DemoForm.js
import React, { useState, useEffect } from "react";
import DemoFormImg from "../image/DemoForm_img.png"
import "./DemoForm.css";

const DemoForm = ({ selectedPlan }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    restaurant: "",
    message: "",
    plan: selectedPlan ? selectedPlan.name : "Professional" // default
  });

  const [status, setStatus] = useState("");

  // Sync selected plan when user changes it in Pricing
  useEffect(() => {
    if (selectedPlan) {
      setFormData((prev) => ({ ...prev, plan: selectedPlan.name }));
    } else {
      setFormData((prev) => ({ ...prev, plan: "Professional" })); // fallback
    }
  }, [selectedPlan]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Submitting...");

    try {
      const res = await fetch("https://myfoodtown-api.wavesdrive.com/web/sendEnquirey/mail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      if (res.ok) {
        setStatus("Request sent successfully! Our team will contact you.");
        setFormData({
          name: "", email: "", phone: "", restaurant: "", message: "",
          plan: selectedPlan ? selectedPlan.name : "Professional"
        });
      } else {
        setStatus(` Error: ${data.message}`);
      }
    } catch (err) {
      setStatus("Something went wrong. Try again later.");
    }
  };

  return (
    <section id="contact">
      <>
        <h2 className="demo-title">Schedule a Free Demo</h2>
        <div className="demoForm">
          <form onSubmit={handleSubmit} className="demoForm-left">
            <div className="form-grid">
              <input type="text" name="name" placeholder="Your Name"
                value={formData.name} onChange={handleChange} required />
              <input type="tel" name="phone" placeholder="Phone Number"
                value={formData.phone} onChange={handleChange} />
              <input type="email" name="email" placeholder="Your Email"
                value={formData.email} onChange={handleChange} required />
              <input type="text" name="restaurant" placeholder="Restaurant Name"
                value={formData.restaurant} onChange={handleChange} />
              <textarea name="message" placeholder="Your Message"
                value={formData.message} onChange={handleChange}
                rows="4" className="full-width" />

              {/* Hidden input to include selected plan */}
              <input type="hidden" name="plan" value={formData.plan} />

              <div className="full-width submit-row">
                <button type="submit" disabled={status === "Submitting..."}>
                  {status === "Submitting..." ? "Submitting..." : "Submit"}
                </button>
                <p>{status}</p>
              </div>
            </div>
          </form>

          <div className="demoForm-right">
            <img src={DemoFormImg} alt="DemoForm" />
          </div>
        </div>
      </>
    </section>
  );
};

export default DemoForm;
